<template>
  <div class="page-title__head">
    <div class="d-flex justify-content-between w-100">
      <h1 class="page-title__text">
        <slot>{{ title }}</slot>
      </h1>
      <slot name="right" />
    </div>
    <slot name="tagline" />
    <hr class="page-title__hr">
  </div>
</template>

<script>
export default {
  name: 'PageTitle',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.page-title {
    // &__head {

    // }
    &__hr{
        border-color: rgba(black, 0.3);
        margin-top: 1rem;
    }

    &__text {
        font-family: $title-font-family;
        font-weight: bold;
        font-size: 2rem;
        padding-bottom: 0;
        margin-bottom: 0;

    }
}
</style>
